// Human character portraits for LifeOS agents
export const AVATARS = [
  "https://static.prod-images.emergentagent.com/jobs/1ff839d8-f836-489e-94e3-d503cbb03325/images/80648e9128d8746ae44939b7cfc030d8ab55e8f82877a6dfd44f3bef227b7d4d.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/1ff839d8-f836-489e-94e3-d503cbb03325/images/44420c09a579fc647762021ef8270893ae23a4b5e578156c8a28188a03939172.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/1ff839d8-f836-489e-94e3-d503cbb03325/images/6c67799ebcc229827668d9653217454397257f1b428eb4268d7a3155050b52e8.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/1ff839d8-f836-489e-94e3-d503cbb03325/images/e245f09fbf1724abdc738397c674cdaa11ac9b442908ce3be24206cf9e0c1514.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/1ff839d8-f836-489e-94e3-d503cbb03325/images/b6b4ef77083f4a0faf160342e98d05754c17573786dbe9e88dcdaa4accdaefe0.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/1ff839d8-f836-489e-94e3-d503cbb03325/images/f0d779dc8384000ec4d403e470b0ee4f5396318734a6e9477190827d7313ab19.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/1ff839d8-f836-489e-94e3-d503cbb03325/images/9435c6bd595a69b0dd4646d4330cd663745520c5c0600cc5a68c03ace9947d37.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/1ff839d8-f836-489e-94e3-d503cbb03325/images/e5e1bba28f05714ce82eb8f1c45baf7473e8b91adaf231bf457eac08bc7ec29f.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/1ff839d8-f836-489e-94e3-d503cbb03325/images/d05864e70b8ec76c777f3c21b74a5b4d5483833501b165e3bab5c65801161bfa.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/1ff839d8-f836-489e-94e3-d503cbb03325/images/d8a969ca47af65179290dac0817234f2fcd8a77a3dc26e278b372cce91b24634.jpeg",
];

export function avatarForId(id) {
  if (!id) return AVATARS[0];
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0;
  return AVATARS[h % AVATARS.length];
}

export function avatarFor(agent) {
  if (agent && agent.avatar_url) return agent.avatar_url;
  return avatarForId(agent ? agent.id : "");
}
